var map = {
	"./01_get_currentTrack.json": "0uty",
	"./02_post_close_currentTrack.json": "6Kq+",
	"./03_post_tpsl_currentTrack.json": "Aoay",
	"./05_swap_trader_detail.json": "t/o3",
	"./06_swap_trader_profit_summary.json": "C/st",
	"./07_swap_trader_profit_detail.json": "F3OC",
	"./08_swap_trader_set_commission.json": "Dog/",
	"./09_swap_trader_trading_pair.json": "Sp22"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "w/qJ";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/copyTrade/api/pFuturesTrader \.json$
// module id = w/qJ
// module chunks = 3